<template>
  <div class="main">
    <div class="bgimg">
      <div class="navlogo">
        <van-image
          class="image"
          :src="
            $global.account_url+hsopInfo.hosp_icon
          "
          round
          width="5vh"
          height="5vh"
        >
        </van-image>
        <div class="hosname">{{hsopInfo.hospital_name}}</div>
      </div>
      <div class="navtitle">
        <div class="titele_head">参考国家卫健委</div>
        <div class="titele_mid">
          《关于在疫情防控中做好互联网诊疗咨询服务工作的通知》
        </div>
        <div class="titele_foot">
          此自诊内容经供参考，不代表诊疗意见，不涉及用户隐私
        </div>
      </div>
      <div class="nav">
        <div class="navcontent">
          <van-grid :column-num="3">
            <van-grid-item
              v-for="(item, index) in icons"
              :border="false"
              :key="index"
              border="false"
              @click="golink(item.link)"
              :icon="$global.account_url+item.url"
              :text="item.name"
            />
          </van-grid>
        </div>
        <div class="cell_box">
          <div>
            <strong class="cell_text"
              >早治疗、早发现、早诊断、早隔离、早治疗，
              是防治新型冠状病毒肺炎的关键。</strong
            >
          </div>
        </div>
      </div>
    </div>

    <div class="foot">
      <div class="btnlist">
        <div class="btn_noe" @click="show = true">预防指南</div>
        <div class="btn_two" @click="godept">进入问诊</div>
      </div>
      <div class="btntext">技术支持与维护：达远软件</div>
    </div>
    <van-popup v-model="show" round :style="{ width: '80%' }">
      <div class="pop">
        <div class="pophead">预防指南</div>
        <div class="poptext">
          <div class="poptext_head">公众如何做好个人预防？</div>
          <div class="poptext_content">
            <div class="titel_color">一、尽量减少外出活动</div>
            （一）避免去疾病正在流行的地区。<br />
            （二）建议春节期间减少走亲访友和聚餐，尽量在家休息。<br />
            （三）减少到人员密集的公共场所活动，尤其是空气流动性差的地方，例如公共浴池、温泉、影院、网吧、KTV、商场、车站、机场、码头、展览馆等。<br />
            <div class="titel_color">二、个人防护和手卫生</div>
            （一）外出佩戴口罩。外出前往公共场所、就医和乘坐公共交通工具时，佩戴医用外科口罩或N95口罩。<br />
            （二）随时保持手卫生。减少接触公共场所的公共物品和部位；从公共场所返回、咳嗽手捂之后、饭前便后，用洗手液或香皂流水洗手，或者使用含酒精成分的免洗洗手液；不确定手是否清洁时，避免用手接触口鼻眼；打喷嚏或咳嗽时，用手肘衣服遮住口鼻。<br />
            <div class="titel_color">三、健康监测与就医</div>
            （一）主动做好个人与家庭成员的健康监测，自觉发热时要主动测量体温。家中有小孩的，要早晚摸小孩的额头，如有发热要为其测量体温。<br />
            （二）若出现可疑症状，应主动戴上口罩及时就近就医。若出现新型冠状病毒感染可疑症状（包括发热、咳嗽、咽痛、胸闷、呼吸困难、轻度纳差、乏力、精神稍差、恶心呕吐、腹泻、头痛、心慌、结膜炎、轻度四肢或腰背部肌肉酸痛等），应根据病情，及时到医疗机构就诊。并尽量避免乘坐地铁、公共汽车等交通工具，避免前往人群密集的场所。就诊时应主动告诉医生自己的相关疾病流行地区的旅行居住史，以及发病后接触过什么人，配合医生开展相关调查。<br />
            <div class="titel_color">四、保持良好卫生和健康习惯</div>
            （一）居室勤开窗，经常通风<br />
            （二）家庭成员不共用毛巾，保持家居、餐具清洁，勤晒衣被。<br />
            （三）不随地吐痰，口鼻分泌物用纸巾包好，弃置于有盖垃圾箱内。<br />
            （四）注意营养，适度运动。<br />
            （五）不要接触、购买和食用野生动物（即野味）；尽量避免前往售卖活体动物（禽类、海产品、野生动物等）的市。<br />
            （六）家庭备置体温计、医用外科口罩或N95口罩、家用消毒用品等物资。<br />
            有疾病流行地区居住旅行史的人员应该怎么做？<br />
            （一）尽快到所在村支部或社区进行登记，减少外出活动，尤其是避免到人员密集的公共场所活动。<br />
            （二）从离开疾病流行地区的时间开始，连续14天进行自我健康状况监测，每天两次。条件允许时，尽量单独居住或居住在通风良好的单人房间，并尽量减少与家人的密切接触。<br />>
            　　
            （三）若出现可疑症状（包括发热、咳嗽、咽痛、胸闷、呼吸困难、轻度纳差、乏力、精神稍差、恶心呕吐、腹泻、头痛、心慌、结膜炎、轻度四肢或腰背部肌肉酸痛等），应根据病情及时就诊。就医途中具体指导建议如下：<br />
            　1.前往医院的路上，病人应该佩戴医用外科口罩或N95口罩。<br />
            2.如果可以，应避免乘坐公共交通工具前往医院，路上打开车窗。<br />
            3.时刻佩戴口罩和随时保持手卫生。在路上和医院时，尽可能远离其他人（至少1米）。
            4.若路途中污染了交通工具，建议使用含氯消毒剂或过氧乙酸消毒剂，对所有被呼吸道分泌物或体液污染的表面进行消毒。<br />
            <div class="titel_color">家庭日常如何做好预防？</div>
            （一）避免去疾病正在流行的地区。<br />
            （二）减少到人员密集的公共场所活动，尤其是空气流动性差的地方，例如公共浴池、温泉、影院、网吧、KTV、商场、车站、机场、码头、展览馆等。<br />
            （三）不要接触、购买和食用野生动物（即野味），避免前往售卖活体动物（禽类、海产品、野生动物等）的市场，禽肉蛋要充分煮熟后食用。<br />
            （四）居室保持清洁，勤开窗，经常通风。<br />
            （五）随时保持手卫生。减少接触公共场所的公共物品和部位；从公共场所返回、咳嗽用手捂之后、饭前便后，用洗手液或香皂流水洗手，或者使用含酒精成分的免洗洗手液；不确定手是否清洁时，避免用手接触口鼻眼；打喷嚏或咳嗽时用手肘衣服遮住口鼻。<br />
            （六）外出佩戴口罩。外出前往公共场所、就医和乘坐公共交通工具时，应佩戴医用外科口罩或N95口罩。<br />
            （七）保持良好卫生和健康习惯。家庭成员不共用毛巾，保持家居、餐具清洁，勤晒衣被。不随地吐痰，口鼻分泌物用纸巾包好，弃置于有盖垃圾箱内。注意营养，勤运动。<br />
            （八）主动做好个人及家庭成员的健康监测。自觉发热时要主动测量体温。家中有小孩的，要早晚摸小孩的额头，如有发热要为其测量体温。<br />
            （九）准备常用物资。家庭备置体温计、一次性口罩、家庭用的消毒用品等物资。<br />
            <div class="titel_color">家庭成员出现可疑症状时怎么做？</div>
            （一）若出现新型冠状病毒感染的肺炎可疑症状（如发热、咳嗽、咽痛、胸闷、呼吸困难、轻度纳差、乏力、精神稍差、恶心呕吐、腹泻、头痛、心慌、结膜炎、轻度四肢或腰背部肌肉酸痛等症状），应根据病情及时就医。<br />
            （二）避免乘坐地铁、公共汽车等公共交通工具，避免前往人群密集的场所。<br />
            （三）就诊时应主动告诉医生自己的相关疾病流行地区的旅行居住史，以及发病后接触过什么人，配合医生开展相关调查。<br />
            （四）患者的家庭成员应佩戴口罩，与无症状的其他家庭成员保持距离，避免近距离接触。<br />
            （五）若家庭中有人被诊断为新型冠状病毒感染的肺炎，其他家庭成员如果经判定为密切接触者，应接受14天医学观察。<br />>
            　（六）对有症状的家庭成员经常接触的地方和物品进行消毒。
            <div class="titel_color">公共场所如何做好预防？</div>
            一、公共场所工作人员要自行健康监测，若出现新型冠状病毒感染的可疑症状（如发热、咳嗽、咽痛、胸闷、呼吸困难、轻度纳差、乏力、精神稍差、恶心呕吐、腹泻、头痛、心慌、结膜炎、轻度四肢或腰背部肌肉酸痛等），不要带病上班。<br />
            二、若发现新型冠状病毒感染的可疑症状者，工作人员应要求其离开。<br />
            三、公用物品及公共接触物品或部位要定期清洗和消毒。<br />
            四、保持公共场所内空气流通。保证空调系统或排气扇运转正常，定期清洗空调滤网，加强开窗通风换气。<br />
            五、洗手间要配备足够的洗手液，保证水龙头等供水设施正常工作。<br />
            六、保持环境卫生清洁，及时清理垃圾。<br />
            七、疾病流行地区，公众应尽量减少前往公共场所，尤其避免前往人流密集和空气流通较差的地方。
            公共交通工具如何做好预防？<br />
            一、发生疾病流行地区的公共交通工具在岗工作人员应佩戴医用外科口罩或N95口罩，并每日做好健康监测。<br />
            二、公共交通工具建议备置体温计、口罩等物品。<br />
            三、增加公共交通工具清洁与消毒频次，做好清洁消毒工作记录和标识。<br />
            四、保持公共交通工具良好的通风状态。<br />
            五、保持车站、车厢内的卫生整洁，及时清理垃圾。<br />
            六、做好人员工作与轮休安排，确保司乘人员得到足够休息。<br />
            <div class="titel_color">病例密切接触者如何做好居家医学观察？</div>
            （一）将密切接触者安置在通风良好的单人房间，拒绝一切探访。<br />
            （二）限制密切接触者活动，最小化密切接触者和家庭成员活动共享区域。确保共享区域（厨房、浴室等）通风良好（保持窗户开启）。<br />
            （三）家庭成员应住在不同房间，如条件不允许，和密切接触者至少保持1米距离。哺乳期母亲可继续母乳喂养婴儿。<br />
            （四）其他家庭成员进入密切接触者居住空间时应佩戴口罩，口罩需紧贴面部，在居住空间中不要触碰和调整口罩。口罩因分泌物变湿、变脏，必须立即更换。摘下并丢弃口罩之后，进行双手清洗。<br />
            （五）与密切接触者有任何直接接触，或离开密接接触者居住空间后，需清洁双手。准备食物、饭前便后也均应清洁双手。如果双手不是很脏，可用酒精免洗液清洁。如双手比较脏，则使用肥皂和清水清洗。（注意酒精使用安全，如意外吞食用或引发火灾）。<br />
            （六）使用肥皂和清水洗手时，最好使用一次性擦手纸。如果没有，用洁净的毛巾擦拭，毛巾变湿时需要更换。<br />
            （七）偶然咳嗽或打喷嚏时用来捂住口鼻的材料可直接丢弃，或者使用之后正确清洗（如用普通的肥皂/洗涤剂和清水清洗手帕）。<br />
            （八）家属应尽量减少与密切接触者及其用品接触。如避免共用牙刷、香烟、餐具、饭菜、饮料、毛巾、浴巾、床单等。餐具使用后应使用洗涤剂和清水清洗。<br />
            （九）推荐使用含氯消毒剂和过氧乙酸消毒剂，每天频繁清洁、消毒家庭成员经常触碰的物品，如床头柜、床架及其他卧室家具。至少每天清洁、消毒浴室和厕所表面一次。<br />
            （十）使用普通洗衣皂和清水清洗密切接触者衣物、床单、浴巾、毛巾等，或者用洗衣机以60-90摄氏度和普通家用洗衣液清洗，然后完全干燥上述物品。将密切接触者使用的床品放入洗衣袋。不要甩动衣物，避免直接接触皮肤和自己的衣服。<br />
            （十一）戴好一次性手套和保护性衣物（如塑料围裙）再去清洁和触碰被密切接触者的人体分泌物污染的物体表面、衣物或床品。戴手套前、脱手套后要进行双手清洁及消毒。<br />
            （十二）若确诊病例的密切接触者出现可疑症状，包括发热、咳嗽、咽痛、胸闷、呼吸困难、轻度纳差、乏力、精神稍差、恶心呕吐、腹泻、头痛、心慌、结膜炎、轻度四肢或腰背部肌肉酸痛等，应立即就医。具体指导建议如下：<br />
            1.前往医院的路上，病人应该佩戴医用外科口罩或N95口罩。<br />>
            2.如果可以，避免乘坐公共交通工具前往医院，路上打开车窗。<br />
            3.时刻佩戴口罩和随时保持手卫生。在路上和医院时，尽可能远离其他人（至少1米）。<br />
            4.若路途中污染了交通工具，建议使用含氯消毒剂或过氧乙酸消毒剂，对所有被呼吸道分泌物或体液污染的表面进行消毒。<br />
            老人、儿童等特殊人群如何做好防护？<br />
            人群对新型冠状病毒普遍缺乏免疫力，老年人、青壮年以及儿童均有发病。老人、儿童应做好日常防护，勤洗手，外出戴口罩，注意平衡膳食，合理营养，适度运动，保持居住环境清洁，保持室内空气流通。<br />
            <div class="titel_color">如何增强免疫力做好其他防护？</div>
            一、无论是咳嗽、喷嚏、流鼻涕，要用纸张、手帕遮挡。<br />
            二、人与人之间接触时，要保持1米以上的距离。<br />
            三、尽量避免到人群密集的地方，保持室内通风换气。<br />
            四、多进行体育锻炼，增强体质、增强免疫力。
            五、避免身体抵抗力下降，合理休息、不熬夜、不过劳<br />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      icons:[
        {
          url:"/datainfo_pic/Interrogation/dh_1.jpg",
          name:"在线问诊",
          link:"#"
        },
        {
          url:"/datainfo_pic/Interrogation/dh_2.jpg",
          name:"实时辟谣",
          link:"https://vp.fact.qq.com/home"
        },
        {
          url:"/datainfo_pic/Interrogation/dh_3.jpg",
          name:"防控知识",
          link:"http://www.nhc.gov.cn/xcs/kpzs/list_gzbd.shtml"
        },
          {
          url:"/datainfo_pic/Interrogation/dh_4.jpg",
          name:"实时疫情",
          link:"https://news.qq.com/hdh5/feiyanarea.htm#/area/?pool=yn"
        },
         {
          url:"/datainfo_pic/Interrogation/dh_5.jpg",
          name:"同城查询",
          link:"https://rl.inews.qq.com/h5/trip?from=newsapp"
        },
        {
          url:"/datainfo_pic/Interrogation/dh_6.jpg",
          name:"病患轨迹",
          link:"https://xw.qq.com/act/fytrace?pgv_ref=txxwapp&ADTAG=txxwapp"
        },
      ],
      hsopInfo:{},
      deptid:"",
    };
  
  },
  mounted(){
    this.init()
  },
    methods: {
      golink(link){
        if(link =="#"){
          this.$toast.fail('该功能暂未开放')
        }
        window.location.href=link
      },
      
       async getdeptid(){
      //请求医院信息
      try {
        this.$showLoad()
        this.isLoad = true
        let url = 'register/feverClinicDeptID'
       await this.$axios_request.request_data("nodeserver", url, "post", null,(data)=>{
        //医院名
        this.$hideLoad()
        this.deptid =data.data.value
       });
      } catch (error) {
        console.log(error)
        this.$hideLoad()
        this.$toast.fail('网络连接失败');
      }
    },
      async init(){
      //请求医院信息
      try {
        this.$showLoad()
        this.isLoad = true
        let url = '/index/getBasicIndex'
       await this.$axios_request.request_data("nodeserver", url, "post", null,(data)=>{
        //医院名
        this.hsopInfo=data.data.basic_info
        this.getdeptid()
        this.$hideLoad()
       });
      } catch (error) {
        console.log(error)
        this.isLoad = false
        this.$hideLoad()
        this.$toast.fail('网络连接失败');
      }
    },
    godept(){
      this.$toast.fail('该功能暂未开放')
    },
    },
};
</script>

<style lang="scss" scoped>
html {
  font-size: 50px;
}
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  .bgimg {
    display: flex;
    flex-direction: column;
    background-image: url("../../assets/Interrogation_pic/nav_bj.png");
    background-repeat: repeat;
    width: 100%;
    height: 45vh;
     background-repeat: no-repeat;   //不重复
    background-size: 100% 100%;     // 满屏
    .navtitle {
      display: flex;
      flex-direction: column;
      width: 95%;
      margin: 0px auto;
      margin-top: 8px;
      font-size: 50px;
      .titele_head {
        line-height: 4vh;
        overflow:hidden;
        height: 5vh;
        width: 90%;
        margin: 0px auto;
        font-size: 1rem;
        line-height: 5vh;
        color: #fafafa;
      }
      .titele_mid {
        line-height: 4vh;
        overflow:hidden;
        height: 3vh;
        width: 95%;
        margin: 0px auto;
        font-size: 0.5rem;
        color: #fafafa;
      }
      .titele_foot {
        line-height: 4vh;
        overflow:hidden;
        height: 3vh;
        width: 90%;
        margin: 0px auto;
        font-size: 0.4rem;
        margin-bottom: 8px;
        color: #fafafa;
      }
    }
  }
  .navlogo {
    display: flex;
    flex-direction: row;
    width: 90%;
    margin: 0px auto;
    height: 5vh;
    .image {
      margin-top: 8px;
      height: 5vh;
    }
    .hosname {
      font-size: 10px;
      line-height: 20px;
      align-self: center;
      align-items: center;
      margin-left: 8px;
      color: #fafafa;
    }
  }
  .cell_box {
    display: flex;
    width: 90%;
    height: 10vh;
    min-height: 8vh;
    padding: 10px 8px;
    margin: 0px auto;
    margin-top: 15px;
    background: #eef4fe;
    border-radius: 5px;
    font-size: 16px;
    .cell_text {
      font-size: 0.7rem;
      color: #5b8df6;
      line-height: 4vh;
    }
  }
  .nav {
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: 0px auto;
    .navcontent {
      width: 90%;
      margin: 0px auto;
      box-shadow: 0 0.24rem 0.48rem 0 rgba(198, 187, 224, 0.15);
    }
  }
  .foot {
    position: fixed;
    bottom: 10vh;
    width: 100%;
    .btnlist {
      width: 95%;
      margin: 0px auto;
      display: flex;
      flex-direction: row;

      .btn_noe {
        width: 30%;
        height: 5vh;
        border: 1px solid #5b8df6;
        text-align: center;
        font-size: 16px;
        line-height: 5vh;
        border-radius: 999px;
        color: #5b8df6;
        margin: 0px auto;
        margin-right: 10px;
      }
      .btn_two {
        width: 30%;
        height: 5vh;
        border: 1px solid #5b8df6;
        text-align: center;
        font-size: 16px;
        line-height: 5vh;
        border-radius: 999px;
        background-color: #5b8df6;
        margin: 0px auto;
        color: #fafafa;
      }
    }
    .btntext {
      width: 100%;
      text-align: center;
      position: fixed;
      bottom: 0;
      font-size: 14px;
    }
  }
  .pop {
    display: flex;
    flex-direction: column;
    .pophead {
      width: 100%;
      text-align: center;
      font-size: 18px;
      line-height: 49px;
      background-color: #5b8df6;
      color: #fafafa;
    }
    .poptext {
      display: flex;
      flex-direction: column;
      overflow: scroll;
      letter-spacing: 3px;
      flex-shrink: 0;
      font-size: 14px;
      height: 50vh;
      padding: 5px;
      line-height: 22px;
      width: 95%;
      margin: 0px auto;
      .poptext_head {
        letter-spacing: 0px;
        width: 99%;
        margin: 0px auto;
        text-align: left;
        font-size: 16px;
        height: 10vh;
        line-height: 44px;
        border-bottom: 1px solid #f1f1f1;
      }
      .poptext_content {
        margin-top: 8px;
        color: #666;
        .titel_color {
          letter-spacing: 4px;
          margin-top: 8px;
          color: #333;
        }
      }
    }
  }
}

.van-popup--center.van-popup--round {
  border-radius: 10px;
}
</style>